import React from "react";
import "./EventFilters.css";

/**
 * EventFilters component provides controls for filtering events
 *
 * @param {Object} props
 * @param {number} props.daysAhead - Number of days ahead to filter events
 * @param {Function} props.onDaysAheadChange - Function to call when days ahead changes
 * @param {boolean} props.loading - Whether data is currently loading
 * @param {number} props.selectedCount - Number of currently selected events
 * @param {Function} props.onRefresh - Function to call to refresh events data
 * @param {Function} props.onSubmitToCalendar - Function to call to post events to calendar
 * @returns {JSX.Element}
 */
const EventFilters = ({
  daysAhead,
  onDaysAheadChange,
  loading,
  selectedCount,
  onRefresh,
  onSubmitToCalendar,
  canPost = false,
}) => {
  return (
    <div className="actions-bar events-actions">
      <div className="days-filter">
        <label htmlFor="daysAhead">Days ahead:</label>
        <input
          type="number"
          id="daysAhead"
          min="1"
          max="30"
          value={daysAhead}
          onChange={onDaysAheadChange}
        />
      </div>
      <div className="action-buttons">
        <button onClick={onRefresh} disabled={loading} className="refresh-btn">
          Refresh Events
        </button>
        {canPost && (
          <button
            onClick={onSubmitToCalendar}
            disabled={loading || selectedCount === 0}
            className="calendar-btn"
          >
            Post Selected to Calendar ({selectedCount})
          </button>
        )}
      </div>
    </div>
  );
};

export default EventFilters;
